import React, { useEffect, useState } from 'react';
import {
  Col,
  Form,
  Radio,
  Row,
  Typography,
} from 'antd';

import {
  listCategoryEquipment,
  listTemplateSizes,
  listPersonalInterests,
  listAllStates,
  listTeamSizes,
  listJerseySizes,
  listPurchaseFrquencies,
} from '../../services/catalogs';
import { Checkbox } from 'antd';
import { Input } from 'antd';
import { Select } from 'antd';
import { InputNumber } from 'antd';

const { Title } = Typography;
const INTEREST_MIN = 3;

const OwnerProfile = ({ role }) => {

  /* ========================
     Catálogos
  ========================= */
  
  const [categories, setCategories] = useState([]);
  const [templateSizes, setTemplateSizes] = useState([]);
  const [interests, setInterests] = useState([]);
  const [statesGeneral, setStatesGeneral] = useState([]);
  const [teamSizes, setTeamSizes] = useState([]);
  const [purchaseFrequencies, setPurchaseFrequencies] = useState([]);
  const [jerseySizes, setJerseySizes] = useState([]);

  useEffect(() => {
    listCategoryEquipment().then(setCategories);
    listTemplateSizes().then(setTemplateSizes);
    listPersonalInterests().then(setInterests);
    listAllStates().then(setStatesGeneral);
    listTeamSizes().then(setTeamSizes);
    listPurchaseFrquencies().then(setPurchaseFrequencies);
    listJerseySizes().then(setJerseySizes);
  }, [role]);

  return (
    <>
      <Title level={5}>DT / Organizador / Dueño</Title>

        <>
          {['DIRECTOR_TECNICO', 'DUENO_EQUIPO'].includes(role?.code) && (
            <>
            {/* Categoría del equipo */}
            <Form.Item
              label="Selecciona la categoría del equipo"
              name={['ownerProfile', 'categoryEquipmentId']}
              rules={[{ required: true, message: 'Campo obligatorio' }]}
            >
              <Radio.Group>
                {categories.map(c => (
                  <Radio key={c.id} value={c.id}>
                    {c.name}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>

            {/* Tamaño plantilla */}
            <Form.Item
              label="Tamaño de tu plantilla"
              name={['ownerProfile', 'templateSizeId']}
              rules={[{ required: true, message: 'Campo obligatorio' }]}
            >
              <Radio.Group>
                {templateSizes.map(t => (
                  <Radio key={t.id} value={t.id}>
                    {t.name}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>

            {/* Uniformes */}
            <Form.Item
              label="¿Gestionas la compra de uniformes?"
              name={['ownerProfile', 'manageUniforms']}
              rules={[{ required: true, message: 'Campo obligatorio' }]}
            >
              <Radio.Group>
                <Radio value={true}>Sí</Radio>
                <Radio value={false}>
                  No, cada uno compra su uniforme
                </Radio>
              </Radio.Group>
            </Form.Item>
          </>
        )}

        {['ORGANIZADOR_LIGA'].includes(role?.code) && (
          <>

            <Col xs={24} md={8}>
              <Form.Item
                label="Nombre de la Liga"
                name={['ownerProfile', 'leagueName']}
                rules={[{ required: true, message: 'Campo obligatorio' }]}
              >
                <Input />
              </Form.Item>
            </Col>
            {/* Tamaño plantilla */}
            <Form.Item
              label=" Número aproximado de equipos en tu liga"
              name={['ownerProfile', 'teamSizeId']}
              rules={[{ required: true, message: 'Campo obligatorio' }]}
            >
              <Radio.Group>
                {teamSizes.map(t => (
                  <Radio key={t.id} value={t.id}>
                    {t.name}
                  </Radio>
                ))}
              </Radio.Group>
            </Form.Item>
            <Col xs={24} md={3}>
              <Form.Item label="Ubicación de las canchas principales"
              name={['ownerProfile', 'locationId']}>
                <Select
                    placeholder="Selecciona estado"
                    options={statesGeneral.map(s => ({
                      key: s.id,
                      value: s.id,
                      label: s.description,
                    }))}
                />
              </Form.Item>
            </Col>
          </>
        )}

          {/* Intereses */}
          <Title level={5}>Intereses personales</Title>

          <Form.Item
            name={['ownerProfile', 'interests']}
            rules={[
              {
                validator: (_, value) =>
                  value?.length >= INTEREST_MIN
                    ? Promise.resolve()
                    : Promise.reject(
                        new Error(`Selecciona al menos ${INTEREST_MIN} intereses`),
                      ),
              },
            ]}
          >
            <Checkbox.Group>
              <Row>
                {interests.map(i => (
                  <Col span={8} key={i.id}>
                    <Checkbox value={i.id}>{i.name}</Checkbox>
                  </Col>
                ))}
              </Row>
            </Checkbox.Group>
          </Form.Item>
          {/* Frecuencia compra */}
          <Form.Item
            label="¿Con qué frecuencia compras online?"
            name={['ownerProfile', 'purchaseFrequencyId']}
            rules={[{ required: true }]}
          >
            <Radio.Group>
              {purchaseFrequencies.map(p => (
                <Radio key={p.id} value={p.id}>
                  {p.name}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>

          {/* Jersey */}
          <Form.Item
            label="Talla de Jersey"
            name={['ownerProfile', 'jerseySizeId']}
            rules={[{ required: true }]}
          >
            <Radio.Group>
              {jerseySizes.map(j => (
                <Radio key={j.id} value={j.id}>
                  {j.name}
                </Radio>
              ))}
            </Radio.Group>
          </Form.Item>
          <Row gutter={16}>
            <Col md={6}>
              <Form.Item
                label="Talla de zapato"
                name={['ownerProfile', 'shoeSize']}
                rules={[{ required: true }]}
              >
                <InputNumber
                  min={20}
                  max={50}
                  style={{ width: '100%' }}
                  placeholder="Ej. 27"
                />
              </Form.Item>
            </Col>
          </Row>
        </>
    </>
  );
};

export default OwnerProfile;
